import { rememberReturnToken } from '~/composables/useReturnAccess'

/**
 * A returns email's link opens `/<locale>/returns/<code>?token=<return token>`. The token is kept
 * for the tab and taken off the URL before the app mounts: off the address bar at once, then off
 * the route with a redirect of the navigation that carries it (the first one, or a link followed
 * inside the app). Neither the visible URL, the history entry nor the route keeps it.
 */
const RETURN_PAGE = /^(?:\/[^/]+)?\/returns\/([^/]+)\/?$/

/** The return code of a return page's path; undefined for any other page, the form included. */
function returnCodeOf(path: string): string | undefined {
  const code = RETURN_PAGE.exec(path)?.[1]
  return code && code !== 'new' ? decodeURIComponent(code) : undefined
}

export default defineNuxtPlugin({
  name: 'returns-url-token',
  setup(nuxtApp) {
    const params = new URLSearchParams(window.location.search)
    if (params.has('token') && returnCodeOf(window.location.pathname)) {
      params.delete('token')
      const search = params.toString()
      window.history.replaceState(window.history.state, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`)
    }

    useRouter().beforeEach((to) => {
      const token = to.query.token
      const code = returnCodeOf(to.path)
      if (!code || typeof token !== 'string' || !token)
        return
      nuxtApp.runWithContext(() => rememberReturnToken(code, token))
      const { token: _token, ...query } = to.query
      return { path: to.path, query, hash: to.hash }
    })
  },
})
